<script>
export default {
  functional: true,
  render(
    h,
    {
      props: { option = { tooltip: {} }, data = { data: [] } }
    }
  ) {
    const mapColorStops = {
      artistic: [
        { offset: 0, color: 'rgba(176, 79, 255, 0.30)' },
        { offset: 1, color: 'rgba(255, 135, 135, 0.00)' }
      ],
      creative: [
        { offset: 0, color: 'rgba(255, 194, 6, 0.30)' },
        { offset: 1, color: 'rgba(252, 96, 92, 0)' }
      ],
      logical: [
        { offset: 0, color: 'rgba(57, 185, 255, 0.30)' },
        { offset: 1, color: 'rgba(57, 111, 237, 0.00)' }
      ],
      programming: [
        { offset: 0, color: 'rgba(104, 234, 208, 0.30)' },
        { offset: 1, color: 'rgba(69, 158, 239, 0.00)' }
      ]
    }
    const mapToolTips = {
      artistic:
        'style="background-image: linear-gradient(-135deg, #FF8787 0%, #B04FFF 100%);border-radius: 6px;padding: 10px"',
      creative:
        'style="background-image: linear-gradient(-135deg, #FFC206 0%, #FC605C 100%);border-radius: 6px;padding: 10px"',
      logical:
        'style="background-image: linear-gradient(-135deg, #39B9FF 0%, #396FED 100%);border-radius: 6px;padding: 10px"',
      programming:
        'style="background-image: linear-gradient(-135deg, #68EAD0 0%, #459EEF 100%);border-radius: 6px;padding: 10px"'
    }
    const mapLineColors = {
      artistic: '#B04FFF',
      creative: '#EF841A',
      logical: '#3AA0FF',
      programming: '#26CCB6'
    }
    const { data: cloneData, name, score = 0 } = data
    const resultData = cloneData.map(v => new Date(v.date).Format('M月d日'))
    const resultScore = cloneData.map(v => v.star_score)
    const start = ['', '一星', '二星', '三星', '四星', '五星']
    option.tooltip.formatter = function(params) {
      const tipHtml = `<div ${mapToolTips[name]}>${params[0].axisValue}  ${
        start[Math.round(params[0].data / 5)]
      }</div>`
      return tipHtml
    }
    return (
      <div class="line-chart">
        <div class="flex">
          平均分：
          <rate
            value={(score / 25) * 5}
            disabled
            void-color="#e3feff"
            text-color="#ffe600"
          />
        </div>
        <line-charts
          option={option}
          data={resultScore}
          x-axis-data={resultData}
          line-color={mapLineColors[name]}
          color-stops={mapColorStops[name]}
        />
      </div>
    )
  }
}
</script>
<style lang="stylus" scoped>
.line-chart
  >>> .el-rate__icon
    font-size 16px
    margin-right 2px
</style>
